import * as React from "react";
import { useEffect, useState, useMemo, useCallback } from "react";
import { useDataProvider } from "react-admin";
import useAiInsight from "../../../Components/AiAssistant/useAiInsight";
import { buildAiBaseParams } from "../../../Components/AiAssistant/buildAiBaseParams";
import { Button, Dialog, DialogContent, Typography } from "@material-ui/core";
import GaugeChart from "../../../Components/CustomChart/GaugeChart";
import CockpitSvcUnsvcPnDifferenceViewList from "./CockpitSvcUnsvcPnDifferenceViewList";
import { ViewList } from "@material-ui/icons";

const CockpitSvcUnsvcPnDifference = ({ filterParams }) => {
  const dataProvider = useDataProvider();

  const [chartData, setChartData] = useState([] as any);
  const [chartValue, setChartValue] = useState(0);
  const [open, setOpen] = useState(false);

  const resourceEndpoint = "pbhrequestorders/cockpit/svcunsvcpndifference";

  // const listContext = useList({
  //     data: cockpitPnDifferenceData.filter(x => x.isDifferent),
  //     loading: false,
  //     loaded: true,
  //     perPage: 5

  // })

  const subArcs = [
    // {
    //     limit: 40,
    //     color: '#5BE12C',
    //     showTick: true
    // },
    {
      limit: 20,
      color: "#FFC700",
      showTick: true,
    },
    {
      limit: 100,
      color: "#EA4228",
      showTick: true,
    },
  ];

  const insightParams = useMemo(() => {
    if (!chartData.length) return null;
    const differentPnCount = chartData.filter((d: any) => d.isDifferent).length;
    return {
      ...buildAiBaseParams(filterParams),
      differenceRate: chartValue.toFixed(2),
      totalPnCount: chartData.length.toString(),
      differentPnCount: differentPnCount.toString(),
    };
  }, [filterParams, chartValue, chartData]);
  useAiInsight("cockpitsvcunsvcpndifference", insightParams);

  const GetChartData = useCallback(async () => {
    await dataProvider
      .getList(resourceEndpoint, {
        pagination: { page: 1, perPage: 999999 },
        sort: { field: "id", order: "ASC" },
        filter: filterParams,
      })
      .then(({ data }) => {
        const sum = data.reduce((sum, current) => sum + current.isDifferent, 0);
        const avg = Number(((sum / data.length) * 100).toFixed(2));
        setChartData(data);
        setChartValue(avg);
      })
      .catch(error => {
        console.log(error);
      });
  }, [filterParams, dataProvider]);

  useEffect(() => {
    GetChartData();
  }, [GetChartData]);

  return (
    <>
      <Typography gutterBottom variant="h5" component="h2" align="center">
        Serviceable PN & Core PN Difference
      </Typography>
      <GaugeChart value={chartValue} subArcs={subArcs} />
      <Button fullWidth startIcon={<ViewList />} onClick={() => setOpen(true)} color="primary">
        View
      </Button>
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="max-width-dialog-title"
      >
        <DialogContent>
          <CockpitSvcUnsvcPnDifferenceViewList
            filterParams={filterParams}
            resource={resourceEndpoint}
            basePath={resourceEndpoint}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CockpitSvcUnsvcPnDifference;
